module.exports = __webpack_public_path__ + "static/media/logo-loader.1c98821e.svg";